//PHONE NUMBERS
//SANDRA #1
//export const WHATS_APP_LINK = "555193133726";
//SANDRA #2
//export const WHATS_APP_LINK = "555192166980";
//OFICIAL ATENDIMENTO
export const WHATS_APP_LINK = "5551994141188";

//SANDRA #1
//export const WHATS_APP_TEXT = "51 9313 3726";
//SANDRA #2
//export const WHATS_APP_LINK = "51 9216 6980";
//OFICIAL ATENDIMENTO
export const WHATS_APP_TEXT = "51 99414 1188";
